import { messages as contractCreateFeeMessages } from '../views/fee/contractCreateFeeLang'
import { messages as meterWaterManageMessages } from '../views/fee/meterWaterManageLang'
import { messages as meterTypeManageMessages } from '../views/fee/meterTypeManageLang'
import { messages as returnPayFeeManageMessages } from '../views/fee/returnPayFeeManageLang'
import { messages as feeDiscountManageMessages } from '../views/fee/feeDiscountManageLang'
import { messages as applyRoomDiscountManageMessages } from '../views/fee/applyRoomDiscountManageLang'
import { messages as discountTypeMessages } from '../views/fee/discountTypeLang'
import { messages as listApplyRoomDiscountRecordMessages } from '../views/fee/listApplyRoomDiscountRecordLang'
import { messages as feeReceiptMessages } from '../views/fee/feeReceiptLang'
import { messages as printPayFeeMessages } from '../views/fee/printPayFeeLang'
import { messages as printPayFeeBangTaiMessages } from '../views/fee/printPayFeeBangTaiLang'
import { messages as printPayFeeXiangyunMessages } from '../views/fee/printPayFeeXiangyunLang'
import { messages as printPayFeeXinShiDaiMessages } from '../views/fee/printPayFeeXinShiDaiLang'
import { messages as printPayFeeTianlinMessages } from '../views/fee/printPayFeeTianlinLang'
import { messages as printSmallPayFeeMessages } from '../views/fee/printSmallPayFeeLang'
import { messages as floorShareMessages } from '../views/fee/floorShareLang'
import { messages as shareReadingMessages } from '../views/fee/shareReadingLang'
import { messages as roomFeeImportMessages } from '../views/fee/roomFeeImportLang'
import { messages as shareReadingFeeMessages } from '../views/fee/shareReadingFeeLang'
import { messages as feeComboManageMessages } from '../views/fee/feeComboManageLang'
import { messages as payFeeAuditManageMessages } from '../views/fee/payFeeAuditManageLang'
import { messages as feeComboMemberManageMessages } from '../views/fee/feeComboMemberManageLang'
import { messages as payFeeBatchMessages } from '../views/fee/payFeeBatchLang'
import { messages as listOweFeeMessages } from '../views/fee/listOweFeeLang'
import { messages as oweFeeCallableMessages } from '../views/fee/oweFeeCallableLang'
import { messages as addOweFeeCallableMessages } from '../views/fee/addOweFeeCallableLang'
import { messages as staffFeeManageMessages } from '../views/fee/staffFeeManageLang'
import { messages as feeSummaryMessages } from '../views/fee/feeSummaryLang'
import { messages as roomCreateFeeMessages } from '../views/fee/roomCreateFeeLang.js'
import { messages as propertyFeeMessages } from '../views/fee/propertyFeeLang'
import { messages as batchPayFeeOrderMessages } from '../views/fee/batchPayFeeOrderLang'
import { messages as simplifyAcceptanceMessages } from '../views/simplify/simplifyAcceptanceLang.js'
import { messages as payFeeOrderMessages } from '../views/fee/payFeeOrderLang'
import { messages as refundDepositFeeMessages } from '../views/fee/refundDepositFeeLang'
import { messages as createFeeByComboMessages } from '../views/fee/createFeeByComboLang'
import { messages as owePayFeeOrderMessages } from '../views/fee/owePayFeeOrderLang'
import { messages as printOweFeeMessages } from '../views/fee/printOweFeeLang'
import { messages as feeDetailMessages } from '../views/fee/feeDetailLang'
import { messages as roomCreatePayFeeMessages } from '../views/fee/roomCreatePayFeeLang'
import { messages as printAccountReceiptMessages } from '../views/account/printAccountReceiptLang'
import { messages as printSmallAccountReceiptMessages } from '../views/account/printSmallAccountReceiptLang'
import { messages as listApplyRoomDiscountRecordDetailsMessages } from '../views/fee/listApplyRoomDiscountRecordDetailsLang'
import { messages as roomOweFeeCallableMessages } from '../views/fee/roomOweFeeCallableLang'

export const messages = {
    en: {
        ...contractCreateFeeMessages.en,
        ...meterWaterManageMessages.en,
        ...meterTypeManageMessages.en,
        ...returnPayFeeManageMessages.en,
        ...feeDiscountManageMessages.en,
        ...applyRoomDiscountManageMessages.en,
        ...discountTypeMessages.en,
        ...listApplyRoomDiscountRecordMessages.en,
        ...feeReceiptMessages.en,
        ...printPayFeeMessages.en,
        ...printPayFeeBangTaiMessages.en,
        ...printPayFeeXiangyunMessages.en,
        ...printPayFeeXinShiDaiMessages.en,
        ...printPayFeeTianlinMessages.en,
        ...printSmallPayFeeMessages.en,
        ...floorShareMessages.en,
        ...shareReadingMessages.en,
        ...roomFeeImportMessages.en,
        ...shareReadingFeeMessages.en,
        ...feeComboManageMessages.en,
        ...payFeeAuditManageMessages.en,
        ...feeComboMemberManageMessages.en,
        ...payFeeBatchMessages.en,
        ...listOweFeeMessages.en,
        ...oweFeeCallableMessages.en,
        ...addOweFeeCallableMessages.en,
        ...staffFeeManageMessages.en,
        ...feeSummaryMessages.en,
        ...roomCreateFeeMessages.en,
        ...propertyFeeMessages.en,
        ...batchPayFeeOrderMessages.en,
        ...simplifyAcceptanceMessages.en,
        ...payFeeOrderMessages.en,
        ...refundDepositFeeMessages.en,
        ...createFeeByComboMessages.en,
        ...owePayFeeOrderMessages.en,
        ...printOweFeeMessages.en,
        ...feeDetailMessages.en,
        ...roomCreatePayFeeMessages.en,
        ...printAccountReceiptMessages.en,
        ...printSmallAccountReceiptMessages.en,
        ...listApplyRoomDiscountRecordDetailsMessages.en,
        ...roomOweFeeCallableMessages.en,
    },
    zh: {
        ...contractCreateFeeMessages.zh,
        ...meterWaterManageMessages.zh,
        ...meterTypeManageMessages.zh,
        ...returnPayFeeManageMessages.zh,
        ...feeDiscountManageMessages.zh,
        ...applyRoomDiscountManageMessages.zh,
        ...discountTypeMessages.zh,
        ...listApplyRoomDiscountRecordMessages.zh,
        ...feeReceiptMessages.zh,
        ...printPayFeeMessages.zh,
        ...printPayFeeBangTaiMessages.zh,
        ...printPayFeeXiangyunMessages.zh,
        ...printPayFeeXinShiDaiMessages.zh,
        ...printPayFeeTianlinMessages.zh,
        ...printSmallPayFeeMessages.zh,
        ...floorShareMessages.zh,
        ...shareReadingMessages.zh,
        ...roomFeeImportMessages.zh,
        ...shareReadingFeeMessages.zh,
        ...feeComboManageMessages.zh,
        ...payFeeAuditManageMessages.zh,
        ...feeComboMemberManageMessages.zh,
        ...payFeeBatchMessages.zh,
        ...listOweFeeMessages.zh,
        ...oweFeeCallableMessages.zh,
        ...addOweFeeCallableMessages.zh,
        ...staffFeeManageMessages.zh,
        ...feeSummaryMessages.zh,
        ...roomCreateFeeMessages.zh,
        ...propertyFeeMessages.zh,
        ...batchPayFeeOrderMessages.zh,
        ...simplifyAcceptanceMessages.zh,
        ...payFeeOrderMessages.zh,
        ...refundDepositFeeMessages.zh,
        ...createFeeByComboMessages.zh,
        ...owePayFeeOrderMessages.zh,
        ...printOweFeeMessages.zh,
        ...feeDetailMessages.zh,
        ...roomCreatePayFeeMessages.zh,
        ...printAccountReceiptMessages.zh,
        ...printSmallAccountReceiptMessages.zh,
        ...listApplyRoomDiscountRecordDetailsMessages.zh,
        ...roomOweFeeCallableMessages.zh,
    }
}